import React from 'react';
import { Routes } from 'routes';
import { useTheme } from '@mui/styles';
import { ToastContainer, Slide } from 'react-toastify';

export default function Root() {
  const theme = useTheme();

  return (
    <>
      <Routes />
      <ToastContainer
        position={theme.direction === 'rtl' ? 'bottom-left' : 'bottom-right'}
        theme='colored'
        transition={Slide}
        autoClose={5000}
        rtl={theme.direction === 'rtl'}
      />
    </>
  );
}
